// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link--1zlJM","Smile":"Smile--SvVz3","Steps":"Steps--3Ib5o"};